import React from "react";

export const ErrorMessage = ({ message, className = "" }) => {
  return (
    <p className={`invalid-feedback d-block text-capitalize-first ${(className || "")}`}>{message || ""}</p>
  );
};

export const showContentLoader = (props) => {
  return (
    <div className={`loader ${(props.className || "")}`} />
  );
};
